import { gmailPromotionTabWhitelistSchema } from "@redotech/redo-model/gmail-promotion-tab-whitelist";
import * as z from "zod";

export const getGmailPromotionTabWhitelistStatus = {
  name: "getGmailPromotionTabWhitelistStatus" as const,
  input: z.object({ domain: z.string() }),
  output: gmailPromotionTabWhitelistSchema.nullable(),
};
